// @flow

export default class SpacingBlock {
  lines: number;
  constructor(lines: number = 1) {
    this.lines = lines;
  }
  get text(): string {
    return '\n'.repeat(this.lines - 1);
  }
  set lines(lines: number) {
    this.lines = lines;
  }
  toString() {
    return this.text;
  }
}
